<template>
  <button
    class="relative px-3 py-2"
    :class="[selected ? 'bg-primary-400 text-contrast-primary' : '']"
    :title="
      isComponent ? $t('global.component_of', { name: parentItemName }) : null
    "
  >
    <span
      v-if="quantityError"
      class="absolute right-1 top-1 block aspect-square h-2 w-2 rounded-full bg-red-600"
    ></span>
    <FontAwesomeIcon
      v-if="isComponent"
      :icon="['fal', 'link']"
      class="absolute top-1 left-1 h-2 w-2"
    />
    <span>
      {{ value }}
    </span>
  </button>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'ItemsPaginationButton',
  components: { FontAwesomeIcon },
  props: {
    value: {
      type: Number,
      required: true
    },
    originalItem: {
      type: Object,
      required: true
    },
    parentItemName: {
      type: String,
      required: false,
      default: null
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isComponent() {
      return Boolean(this.parentItemName)
    },
    quantityError() {
      if (!this.originalItem?.item) return false
      return (
        this.originalItem.quantity !==
        Object.values(this.originalItem.stock ?? {})
          .map((item) => item.quantity)
          .filter((n) => parseInt(n) === n)
          .reduce((a, b) => a + b, 0) +
          this.originalItem.order
      )
    }
  }
}
</script>
